/**
 * Channel Row to LIVE section
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.controller('LmChannelRowController', ['$rootScope', '$scope', '$interval', '$location', '$timeout', '$compile', '$templateCache', 'AssetService', 'MetadataService', 'ModalWindowService', 'AssetResource',
  function ($rootScope, $scope, $interval, $location, $timeout, $compile, $templateCache, AssetService, MetadataService, ModalWindowService, AssetResource) {
    $scope.version = jwplayer && jwplayer.version.split('+')[0] || '';

    if (!$scope.asset || $scope.isHeader) {
      return;
    }

    $scope.actionShown = false;

    $scope.parseChannelAsset = function (asset) {

      $scope.assetData = angular.copy(asset);
      $scope.prepareChannelStatus();

      if (!$scope.posterData) $scope.posterData = {};

      var needUpdate = $scope.assetData._status.streams.filter(function (stream) {

        return stream._is_transcoding || !stream.is_deployed;
      });

      if ($scope.updateIntreval && !needUpdate.length && $scope.assetData._status.poster) {
        $interval.cancel($scope.updateIntreval);
      } else if (needUpdate.length || !$scope.assetData._status.poster) {

        if ($scope.updateIntreval) {
          $interval.cancel($scope.updateIntreval);
        }

        $scope.updateIntreval = $interval(function () {

          $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {
            id: $scope.assetData.id,
            isSilentUpdate: true
          });
        }, 30 * 1000);
      }

      AssetService.GetPoster(asset)
        .then(function (url) {
          $scope.posterData.t = _.get(_.find(asset.resources, {type: 'picture'}), 'uptime_time') || Date.now();
          $scope.posterData.url = url;
        });
    };

    $scope.prepareChannelStatus = function () {
      $scope.assetData._status = {
        streams: $scope.assetData.resources.filter(function (resource) {
          return resource.type === 'stream' && !resource.category;
        }).map(function (resource) {
          if (resource.stream_type.indexOf('youtube') !== -1) {
            $scope.assetData._has_youtube = true;
            resource.stream_type = 'youtube';
            resource._stream_sub_type = 'y';
          }

          resource._stream_type = MetadataService._STREAM_TYPES_ATTRS[resource.stream_type];

          return resource;
        }),
        poster: _.find($scope.assetData.resources, {category: 'poster_blueprint'}) && _.find($scope.assetData.resources, {category: 'poster_blueprint'}).is_deployed,
        rental: MetadataService.Rental.Check($scope.assetData),
        catchup: _.find($scope.assetData.resources, {
          category: 'catchup'
        })
      };

    };

    $scope.streamData = {
      isStreamReady: false,
      status: '',
      isStreamAvailable: function (asset) {

        var resources = asset.resources && asset.resources.filter(function (resource) {
            return resource.type === 'stream' && (resource.stream_type === 'hls_live' || resource.stream_type === 'dash_live');
          });

        var isDeployedRes = resources && resources.filter(function (resource) {
            return resource.is_deployed;
          });

        this.status = '';

        switch (true) {
          case !resources || !resources.length:
            this.status = 'No stream data in asset';
            break;

          case !isDeployedRes || !isDeployedRes.length:
            this.status = 'Stream is not deployed yet';
            break;

          default :
            this.status = '';
            break;
        }

        return asset.resources && isDeployedRes && isDeployedRes.length > 0;
      },

      closeStream: function (event) {
        var contentTr = angular.element('#jw_player');

        if (contentTr.length) {
          $rootScope.watchingAssetId = '';
          contentTr.remove();
        }
      },

      openStream: function (asset, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();
        if (asset.id === $rootScope.watchingAssetId) return;

        if (!this.isStreamAvailable(asset)) return;

        this.closeStream();

        $scope.prepareChannelStatus();

        if (asset._status && asset._status.streams.length) {

          AssetService.GetStream(asset, asset._status.streams[0].stream_type, asset._status.streams[0].category)
            .then(function (url) {
              $rootScope.watchingAssetId = asset.id;
              var contentTr = angular.element('<lm-jwplayer url="' + url + '"></lm-jwplayer>');
              contentTr.insertAfter(event.currentTarget.parentNode);
              $compile(contentTr)($scope);
            }.bind(this));
        }
      },

      changeStream: function (index) {
        if ($scope.assetData._status.streams && $scope.assetData._status.streams[index]) {

          AssetService.GetStream($scope.assetData, $scope.assetData._status.streams[index.stream_type], $scope.assetData._status.streams[index].category)
            .then(function (url) {
              $scope.url = url;
            }, function (reason) {
              $scope.playbackError = reason;
            });
        }
      }
    };

    $scope.watchStream = function (asset, event) {
      if (event && event.stopPropagation) event.stopPropagation();
      if (event && event.preventDefault) event.preventDefault();
      if (asset.id === $rootScope.watchingAssetId) return;

      if (!$scope.streamData.isStreamAvailable(asset)) return;

      $scope.selectedStream = '';
      $scope.selectedStreamEscaped = '';
      $scope.selectedStreamType = 'hls';
      $scope.selectedStreamError = '';
      $scope.streamLoading = true;
      $scope.isHLSSupported = false;
      $scope.hlsResourceId = 0;
      $scope.isDASHSupported = false;
      $scope.dashResourceId = false;
      var licence = $location.protocol() + '://'+ $location.host() + '/discovery:80/sdp/v2/assets/'+asset.id+'/wv-license?auth_token='+lh.common.config.get('authToken');
      $scope.license = licence.replace(/^http:\/\//,"https://");

      var hlsResource = asset.resources && asset.resources.filter(function (resource) {
        return resource.type === 'stream' && resource.stream_type === 'hls_live' && resource.is_deployed;
      });
      if (hlsResource.length) {
        $scope.isHLSSupported = true;
        $scope.hlsResourceId = hlsResource[0].id;
      }

      var dashResource = asset.resources && asset.resources.filter(function (resource) {
        return resource.type === 'stream' && resource.stream_type === 'dash_live' && resource.is_deployed;
      });
      if (dashResource.length) {
        $scope.isDASHSupported = true;
        $scope.dashResourceId = dashResource[0].id;
      }

      $scope.getHLSStream = function () {
        if (!$scope.isHLSSupported) return;
        $scope.selectedStream = '';
        $scope.selectedStreamEscaped = '';
        $scope.selectedStreamType = 'hls';
        $scope.selectedStreamError = '';
        $scope.streamLoading = true;
        AssetResource.getStream({ id: asset.id, resourceId: $scope.hlsResourceId }).$promise
            .then(function (response) {
              $scope.selectedStream = response.data;
              $scope.selectedStreamEscaped = escape(response.data);
              $scope.selectedStreamError = '';
              $scope.streamLoading = false;
            })
            .catch(function (reason) {
              $scope.streamLoading = false;
              if (reason.data.error) {
                $scope.selectedStreamError = reason.data.error;
              }
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      $scope.getDASHStream = function () {
        if (!$scope.isDASHSupported) return;
        $scope.selectedStream = '';
        $scope.selectedStreamEscaped = '';
        $scope.selectedStreamType = 'dash';
        $scope.selectedStreamError = '';
        $scope.streamLoading = true;
        AssetResource.getStream({ id: asset.id, resourceId: $scope.dashResourceId }).$promise
            .then(function (response) {
              $scope.selectedStream = response.data;
              $scope.selectedStreamEscaped = escape(response.data);
              $scope.selectedStreamError = '';
              $scope.streamLoading = false;
            })
            .catch(function (reason) {
              $scope.streamLoading = false;
              if (reason.data.error) {
                $scope.selectedStreamError = reason.data.error;
              }
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      $scope.getHLSStream();

      var inner = $templateCache.get('live-watch-stream.tpl.html');
      inner = $compile(inner)($scope);

      $scope.window = ModalWindowService.Open({
        content: inner,
        isFixed: true,
        clear: true,
        keyboard: true,
        actions: [
          {
            title: 'Close',
            color: 'red',
            fn: function () {}
          }
        ],
        size: {
          s: 11,
          l: 8
        }
      });
    };

    $scope.deleteAsset = function (event) {
      if (event && event.stopPropagation) event.stopPropagation();
      if (event && event.preventDefault) event.preventDefault();

      $scope.deleteFn(event);
    };

    $scope.parseChannelAsset($scope.asset);
    $scope.prepareChannelStatus();

    $scope.assetWatcher = $scope.$watchCollection('asset', function (newValue) {
      if (!newValue) return;

      $scope.parseChannelAsset(newValue);
    });

    $scope.$on('$destroy', function () {
      $scope.assetWatcher();
      $interval.cancel($scope.updateIntreval);
    });
  }
]);

lmApp.directive('lmChannelRow', ['$compile', 'AssetService', function ($compile, AssetService) {
  return {
    restrict: 'E',
    scope: {
      asset: '=',
      editFn: '&',
      deleteFn: '&',
      isHeader: '='
    },
    replace: true,
    controller: 'LmChannelRowController',
    templateUrl: 'lm-table-rows/channel-row/channel-row.tpl.html'
  };
}]);
